module.exports = __webpack_public_path__ + "static/media/twitter.fac812ec.svg";